export default "/images/sidebar-4.jpg?59151704b35638cd95da43ba5df24982";